import script from "./MHeaderMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MHeaderMenu.vue?vue&type=script&setup=true&lang=js"

import "./MHeaderMenu.vue?vue&type=style&index=0&id=3ea15a08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea15a08"]])

export default __exports__